export default {
    namespaced: true,

    state: () => {
        return {
            resume: null,
            primaryLenderApplyMode: null,
            applyMode: null,
            data: {},
            selectedPaymentPlan: null,
            maxCalculatorDollars: null,
        }
    },

    mutations: {
        update(state, app) {
            state.data = app
        },

        updateResume(state, resume) {
            state.resume = resume
        },

        updateApplyMode(state, mode) {
            state.applyMode = mode
        },

        updateSelectedPaymentPlan(state, plan) {
            state.selectedPaymentPlan = plan
        },

        updatePrimaryLenderApplyMode(state, mode) {
            state.primaryLenderApplyMode = mode
        },

        updatePurchaserEnabled(state, enabled) {
            state.data.purchaserEnabled = enabled
        },

        updatePurchaseAmountCents(state, value) {
            state.data.purchaseAmountCents = value
        },

        updateMaxCalculatorDollars(state, value) {
            state.maxCalculatorDollars = value
        },

        updateTreatmentType(state, value) {
            state.data.insurance = {
                ...state.data.insurance,
                treatmentType: value,
            }
        },
    },
}
